import { clsx } from 'clsx'
import { type FC, type Ref } from 'react'

import { SliderButton } from '../../../slider'

import { useContactPageLastOrderContext } from './ContactPageLastOrderContext'

import styles from './ContactPageSliderButtonIcon.module.css'

interface Props {
  leftRef: Ref<HTMLButtonElement>
  rightRef: Ref<HTMLButtonElement>
}

export const ContactPageSliderControls: FC<Props> = ({ leftRef, rightRef }) => {
  const { firstSubOrder, lastOrder } = useContactPageLastOrderContext()

  if (!lastOrder || !firstSubOrder) {
    return null
  }

  return (
    <div className="hidden w-full items-center justify-start gap-4 tablet:flex">
      <SliderButton
        aria-label="previous"
        className={clsx(
          'inline-flex size-9 bg-light-brand-high hover:bg-light-pressed-brand-medium',
          styles['contact-page-slider__button-icon'],
        )}
        direction="left"
        ref={leftRef}
      />

      <SliderButton
        aria-label="next"
        className={clsx(
          'inline-flex size-9 bg-light-brand-high hover:bg-light-pressed-brand-medium',
          styles['contact-page-slider__button-icon'],
        )}
        direction="right"
        ref={rightRef}
      />
    </div>
  )
}
